import DrawerToggle from '../Drawer/DrawerToggle';
import classNames from 'classnames';
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A link that triggers the visibility of a help drawer
 */

export const HelpDrawerToggle = _ref => {
  let {
    children,
    className,
    showDrawer,
    helpDrawerOpen,
    icon,
    ...others
  } = _ref;
  return /*#__PURE__*/_jsxs(DrawerToggle, {
    className: classNames(className, 'ds-c-help-drawer__toggle'),
    drawerOpen: helpDrawerOpen,
    showDrawer: showDrawer,
    ...others,
    children: [children, " ", icon]
  });
};
export default HelpDrawerToggle;